"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Turn content into a file and start the download for the user
 * Borrowed from http://bit.ly/2oKP2ll
 */
var downloadFile = function (filename, content) {
    var el = document.createElement('a');
    var file = new File([content], filename, { type: 'application/json' });
    var href = URL.createObjectURL(file);
    el.setAttribute('href', href);
    el.setAttribute('download', filename);
    el.style.display = 'none';
    if (document.body !== null) {
        document.body.appendChild(el);
    }
    el.click();
    if (document.body !== null) {
        document.body.removeChild(el);
    }
};
exports.default = downloadFile;
